import React from 'react';

const LayoutRow = ({children}) =>{
    return(<div className="row">{children}</div>);
};

export default LayoutRow;